import { Fragment, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { connect } from "react-redux";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { addToCart } from "../../store/actions/action";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import axios from "axios";
import Footer from "../../components/footer/Footer";
import ContactForm from "../../components/ContactFrom/ContactForm";
import Navbar2 from "../../components/Navbar2/Navbar2";
import img from "../../images/product-page-title.jpg";
import StarLoader from "../../components/loader/StarLoader";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const ProductSinglePage = ({ addToCart }) => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState(null);
  const [allProducts, setAllProducts] = useState([]);
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    const fetchProduct = axios.get(`${apiUrl}/api/product-list/${id}`);
    const fetchAllProducts = axios.get(`${apiUrl}/api/products-list`);

    Promise.all([fetchProduct, fetchAllProducts])
      .then(([productRes, allRes]) => {
        if (!isMounted) return;
        setProduct(productRes.data);
        setMainImage(productRes.data.banner);
        setAllProducts(allRes.data);
      })
      .catch((err) => console.error("Error fetching product(s):", err))
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [id, apiUrl]);

  // 👇 Show loader while loading is true, else show the full page
  if (loading) {
    return <StarLoader />;
  }

  const relatedProducts = allProducts
    .filter((p) => p.id !== Number(id)) // exclude current product
    .slice(0, 3);

  const buttonContainerStyle = {
    textAlign: "center",
  };

  const buttonStyle = {
    background: "linear-gradient(90deg, #001F5C, #007BFF)",
    color: "#fff",
    border: "none",
    padding: "8px 14px",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background 0.3s ease",
    boxShadow: "0 0 8px rgba(0, 31, 92, 0.5)", // glowing orange shadow for button
  };

  return (
    <Fragment>
      <Navbar2 hclass={"wpo-header-style-1"} />
      <PageTitle pageTitle={product.title} pagesub="Product" img={img} />

      <section
        className="wpo-shop-single-section section-padding"
        style={{
          backgroundColor: "#E6F7FF",
          paddingTop: "40px", // reduce vertical padding
          paddingBottom: "40px", // reduce vertical padding
        }}
      >
        <div className="container">
          {!product ? (
            <p style={{ textAlign: "center", marginTop: "30px" }}>
              Loading product...
            </p>
          ) : (
            <div
              className="row align-items-start"
              style={{
                padding: "40px 20px",
                borderTop: "1px solid #eee",
                borderBottom: "1px solid #eee",
              }}
            >
              {/* Product Images */}
              <div
                className="col col-lg-5 col-12"
                style={{ marginBottom: "20px" }}
              >
                <div
                  className="shop-single-slider"
                  style={{ textAlign: "center" }}
                >
                  {/* Main Image */}
                  <div style={{ marginBottom: "15px" }}>
                    <Zoom>
                      <img
                        src={`${apiUrl}/storage/${mainImage}`}
                        alt={product.title}
                        style={{
                          width: "100%", // Fill full width of parent container
                          maxWidth: "100%", // Prevent overflow
                          height: "350px", // Increase height for larger display
                          objectFit: "cover", // Makes it cover fully, cropping if needed
                          objectPosition: "center", // Center the focus of the image
                          borderRadius: "20px",
                          border: "1px solid lightgray",
                          marginBottom: "15px",
                          backgroundColor: "#f5f5f5", // Optional: fills space for small images
                          boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                        }}
                      />
                    </Zoom>
                  </div>

                  {/* Thumbnails */}
                  {product.images && product.images.length > 0 && (
                    <div
                      style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
                    >
                      {/* Banner Thumbnail */}
                      <img
                        src={`${apiUrl}/storage/${product.banner}`}
                        alt="banner-thumb"
                        onClick={() => setMainImage(product.banner)}
                        style={{
                          width: "90px",
                          height: "90px",
                          objectFit: "cover",
                          borderRadius: "5px",
                          border:
                            mainImage === product.banner
                              ? "2px solid #000"
                              : "1px solid #ddd",
                          cursor: "pointer",
                          boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                        }}
                      />
                      {/* Extra Images */}
                      {product.images.map((img, index) => (
                        <img
                          key={index}
                          src={`${apiUrl}/storage/${img}`}
                          alt={`product-${index}`}
                          onClick={() => setMainImage(img)}
                          style={{
                            width: "90px",
                            height: "90px",
                            objectFit: "cover",
                            borderRadius: "5px",
                            border:
                              mainImage === img
                                ? "2px solid #000"
                                : "1px solid #ddd",
                            cursor: "pointer",
                            boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                          }}
                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Product Details */}
              <div className="col col-lg-7 col-12">
                <div className="product-details" style={{ padding: "0 20px" }}>
                  <h2
                    style={{
                      fontSize: "28px",
                      marginBottom: "15px",
                      color: "#222",
                    }}
                  >
                    {product.title}
                  </h2>

                  <p
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.6",
                      marginBottom: "15px",
                      color: "#555",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: product.description,
                    }}
                  />

                  <p
                    style={{
                      marginLeft: "40px",
                      color: "bdarkblue",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: product.details,
                    }}
                  />

                  <div
                    className="tg-btm"
                    style={{ borderTop: "1px solid #eee", paddingTop: "15px" }}
                  >
                    <p>
                      <span style={{ fontWeight: "bold" }}>Category:</span>{" "}
                      {product.category
                        ? product.category.name
                        : "Uncategorized"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Related Products */}
          {relatedProducts.length > 0 && (
            <div className="related-products" style={{ marginTop: "50px" }}>
              <h3
                style={{
                  marginBottom: "30px",
                  padding: "10px",
                  paddingLeft: "45px",
                  boxShadow: "0 2px 6px rgba(0, 31, 92, 0.4)",
                  borderRadius: "8px",
                }}
              >
                Related Products
              </h3>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                  gap: "20px",
                }}
              >
                {relatedProducts.map((rel) => (
                  <div
                    key={rel.id}
                    style={{
                      background: "#fff",
                      borderRadius: "10px",
                      boxShadow: "0 4px 12px rgba(0, 31, 92, 0.25)",
                      overflow: "hidden",
                      height: "420px",
                      display: "flex",
                      flexDirection: "column",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow =
                        "0 6px 20px rgba(0, 31, 92, 0.45)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 12px rgba(0, 31, 92, 0.25)";
                    }}
                  >
                    {/* Image */}
                    <div style={{ height: "200px", overflow: "hidden" }}>
                      <img
                        src={`${apiUrl}/storage/${rel.banner}`}
                        alt={rel.title}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          objectPosition: "center",
                          transition: "transform 0.4s ease",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.transform = "scale(1.05)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.transform = "scale(1)")
                        }
                      />
                    </div>

                    {/* Details */}
                    <div
                      style={{
                        padding: "15px",
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <Link
                        onClick={ClickHandler}
                        to={`/product-single/${rel.id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <h3
                          style={{
                            fontSize: "18px",
                            marginBottom: "8px",
                            color: "#222",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {rel.title}
                        </h3>
                      </Link>

                      <p
                        style={{
                          flexGrow: 1,
                          color: "#555",
                          fontSize: "14px",
                          lineHeight: 1.4,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                          marginBottom: "10px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: rel.description,
                        }}
                      />
                      <div style={buttonContainerStyle}>
                        <Link
                          onClick={ClickHandler}
                          to={`/product-single/${rel.id}`}
                        >
                          <button
                            style={buttonStyle}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background =
                                "linear-gradient(90deg, #002B80, #339CFF)";
                              e.currentTarget.style.boxShadow =
                                "0 0 15px rgba(0, 123, 255, 0.6)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background =
                                "linear-gradient(90deg, #001F5C, #007BFF)";
                              e.currentTarget.style.boxShadow =
                                "0 0 8px rgba(0, 31, 92, 0.5)";
                            }}
                            data-bs-toggle="tooltip"
                            data-bs-html="true"
                            title="Add to Cart"
                          >
                            View Details
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div style={{ marginTop: "60px", textAlign: "center" }}>
            <div style={{ marginBottom: "25px" }}>
              <h2
                style={{
                  background: "linear-gradient(90deg, darkblue, #1E90FF)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: "700",
                  fontSize: "2rem",
                }}
              >
                Looking to Import or Export Products?
              </h2>
              <p style={{ color: "#4b5563", fontSize: "1.05rem" }}>
                Reach out today and discover how we can support your global
                sourcing and distribution needs.
              </p>
            </div>
            <div className="wpo-contact-form-area">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default connect(null, { addToCart })(ProductSinglePage);
